KMVP.registration = {

    /**
     * Bindings for Login/PreRegister Form
     */
    initLoginRegisterFormHandler: function (rootElementSelector, requestedUrl) {
        var userLoginRegisterElement = $(rootElementSelector).find('.userLoginRegister'),
            loginForm = userLoginRegisterElement.find('#loginForm'),
            $loginBtn = $('.js-button-login-submit');

        loginForm.ajaxForm({
            beforeSubmit: function () {
                $loginBtn.showSpinner();
                $loginBtn.prop("disabled", true);
            },
            success: function (data) {
                if ($(data).find('.globalMessages .alert').length) {
                    var contents = $(data).find('.userLoginRegister');
                    userLoginRegisterElement.html(contents.html());
                    var messageBox = $(data).find('.globalMessages');
                    if ($(".globalMessages").length) {
                        messageBox.prependTo(userLoginRegisterElement);
                    } else {
                        $("#globalMessages").html(messageBox.html());
                    }
                    KMVP.registration.initLoginRegisterFormHandler(rootElementSelector, requestedUrl);
                    $.colorbox.resize();
                    return;
                }

                // login success, now perform requested action

                var targetUrl = KMVP.registration.getAfterLoginUrl(data, requestedUrl);

                ACC.common.waitForAjax(function () {
                    // add hash needed for tracking with google tag manager
                    targetUrl = ACC.track.setUrlHash("currentLogin", window.location.origin + targetUrl + window.location.hash);
                    setTimeout(
                        function () {
                            ACC.track.setUrl(targetUrl);
                        }
                        , 500);
                });
            }
        });

        loginForm.find('.password-forgotten').click(function () {
            $.get($(this).data('url')).done(function (data) {
                $.colorbox({
                    html: data,
                    innerWidth: '600px',
                    height: 'auto',
                    //overlayClose: false,
                    onLoad: function () {
                        $('#cboxClose').remove();
                    },
                    onOpen: function () {
                        $('#validEmail').remove();
                    },
                    onComplete: function () {
                        var $form = $('#forgottenPwdForm');

                        $form.ajaxForm({
                            beforeSubmit: function () {
                                KMVP.forms.disableSubmitButton($form);
                            },
                            success: function (data) {
                                KMVP.forms.enableSubmitButton($form)
                                if ($(data).closest('#validEmail').length) {
                                    if ($('#validEmail').length === 0) {
                                        $('.forgottenPwd').html($(data));
                                        $('#validEmail').removeAttr('class');
                                        $.colorbox.resize();
                                    }
                                } else {
                                    $('#forgottenPwdForm')
                                        .html($(data)
                                            .find('#forgottenPwdForm').html());
                                    $.colorbox.resize();
                                }
                            },
                            error: function () {
                                KMVP.forms.enableSubmitButton($form)
                            }
                        });
                        ACC.common.refreshScreenReaderBuffer();
                    },
                    onClosed: function () {
                        ACC.common.refreshScreenReaderBuffer();
                    }
                });
            });
        });
        // var registrationLink = $('.js-register-new-customer');
        var preRegisterForm = userLoginRegisterElement.find('#preRegisterForm');
        var registrationLink = preRegisterForm.find('.cust_num_link');

        var registrationUrl = registrationLink.data('registration-url');
        var isActivation = registrationLink.data('is-activation');

        registrationLink.click(function (e) {
            e.preventDefault();
            $.get(registrationUrl, function (data) {

                $.colorbox({
                    html: $(data),
                    scrolling: false,
                    innerWidth: 930,
                    onLoad: function () {
                        $('#cboxClose').remove();
                    },
                    onComplete: function () {
                        $.colorbox.resize();
                        if (isActivation) {
                            $('.registrationForm').addClass('activation');
                        }
                        KMVP.registration.initRegistrationFormHandler();
                    },
                    onClosed: function () {
                        KMVP.overlays.setColorBoxFixedPosition(false); // reset fixed position
                    }
                });
            });
        });

        // var preRegisterForm = userLoginRegisterElement.find('#preRegisterForm');
        preRegisterForm.find('.register-button').on('click', function (e) {
            e.preventDefault();

            // disable button to prevent multiple emails
            $('.register-button').prop('disabled', true);

            var form = $(this).closest('form');
            setTimeout(function () {
                var registerUrl = form.attr('action');
                $.post(registerUrl, form.serialize(),
                    function (data) {
                        if ($(data).find('.userLoginRegister').length) {
                            //has errors
                            var contents = $(data).find('.userLoginRegister');
                            userLoginRegisterElement.html(contents.html());
                            var messageBox = $(data).find('.globalMessages');
                            if ($(".globalMessages").length) {
                                messageBox.prependTo(userLoginRegisterElement);
                            } else {
                                $("#globalMessages").html(messageBox.html());
                            }
                            $.colorbox.resize();
                            KMVP.registration.initLoginRegisterFormHandler(rootElementSelector, requestedUrl);
                        } else if ($(data).find('.userRegistration').length) {
                            //unknown customer, known sapId
                            var contents = $(data).find('.userRegistration');
                            userLoginRegisterElement.html(contents.html());
                            KMVP.registration.initRegistrationFormHandler();

                            $.colorbox.resize();
                            KMVP.registration.initLoginRegisterFormHandler(rootElementSelector, requestedUrl);
                        } else {
                            $.colorbox({
                                html: $(data),
                                scrolling: false,
                                innerWidth: 953,
                                onLoad: function () {
                                    $('#cboxClose').remove();
                                },
                                onComplete: function () {
                                    $.colorbox.resize();

                                    $('.registrationConfirmation').find('.close-button').click(function (e) {
                                        $.colorbox.close();
                                    });
                                },
                                onClosed: function () {
                                    if ($(data).find('.js-close-button-to-login').length) {
                                        $('.js-navbar-main-login').trigger('click');
                                    }
                                }
                            });
                        }
                    }
                );
            }, 100);
        });

        preRegisterForm.find('.register-email, .register-sap').one("click", function () {
            $(this).closest('#preRegisterForm').find('.agb-checkbox, .nl-checkbox').removeClass('hidden');
            $.colorbox.resize();
            $(this).focus();
        });

        preRegisterForm.find('#customerEmail, #sapCustomerNumber').one("change", function () {
            if (!preRegisterForm.find('button.popup-button').hasClass('hide')) {
                preRegisterForm.find('button.popup-button').addClass('hide');
            }
            if (preRegisterForm.find('button.register-button').hasClass('hide')) {
                preRegisterForm.find('button.register-button').removeClass('hide');
            }
            userLoginRegisterElement.find('#registrationRequest').remove();
        });
        preRegisterForm.find('.customer-email-unknown').on("click", function (e) {
            e.preventDefault();
            preRegisterForm.find('button').each(function () {
                if ($(this).is(':visible')) {
                    $(this).trigger('click');
                }
                ;
            });
        });
        preRegisterForm.find('.popup-button').on("click", function (e) {
            e.preventDefault();
            $('input[name="secondRegistrationRequestCall"]').val('true'); // notify controller that we are making second request
            var form = $(this).closest('form');
            var registerUrl = form.attr('action');
            $.post(registerUrl, form.serialize(),
                function (data) {
                    if ($(data).find('.hideGlobalErrorMsg').length > 0) {
                        $(".globalMessages").hide(); // hide error from popup
                        $("#globalMessages").hide(); // hide error from /login page
                    }
                    userLoginRegisterElement.find('.error-popup-wrapper').show();
                    userLoginRegisterElement.find('.login-form, .registerForm').hide();
                    $.colorbox.resize({innerWidth: 570});
                });
        });

        KMVP.overlays.initColorboxCloseButtonHandler();

        var openRegisterForm = registrationLink.data('open-register-form');
        if (openRegisterForm === true) {
            registrationLink.click();
        }
    },

    /**
     * @returns {boolean} true if customer is logged in
     */
    isLoggedIn: function () {
        return KMVP.status.isLoggedIn === true;
    },

    /**
     * @returns {boolean} true if redirectToSpartacus is set to true on the Backoffice
     */
    redirectLoginToSpartacus: function () {
        return KMVP.status.redirectLoginToSpartacus === true;
    },

    /**
     * Bindings for Login/PreRegister Form
     */
    initLoginRegisterButtonHandler: function () {

        if (KMVP.registration.isLoggedIn()) {
            return; // no binding required for logged in
        }

        var loginActionSelector = '.js-user-menu-popup-login a, ' +
            '.js-register-customer, ' +
            '.loginbox-button, ' +
            '.js-loginbox-link, ' +
            '.js-navbar-main-login, ' +
            '.js-open-loginbox, ' +
            '.js-pdf-link, ' +
            '[href$="/login?ajax=true"], ' +
            '[href*="/merchant/"], ' +
            '[href*="/my-account"]';

        $(loginActionSelector).off('click.loginButtonAction');
        $(loginActionSelector).on('click.loginButtonAction', function (e) {
            KMVP.registration.openLogin(e);
        });
    },

    openLogin: function(e) {
        e.preventDefault();

        if (KMVP.registration.redirectLoginToSpartacus()) {
            window.location.href = ACC.loginUrl;
        }

        var $this = $(this);
        var href = $this.attr('href');
        var requestedUrl;
        if (!href || (href.length >= 10 && href.substr(0, 10) === 'javascript')) {
            // do not use href for buttons, since this is invalid html - use data-href instead
            if ($this.data("href")) {
                requestedUrl = $this.data("href");
            } else if ($this.hasClass('js-navbar-main-login')) {
                //do not set requestedUrl - we need to redirect user to data.url
                //this is needed only for loginbox
            } else {
                requestedUrl = window.location.href;
            }
        } else {
            requestedUrl = href;
        }

        // now show login box:
        var loginUrl = $('[data-selector="login-button"]').attr('data');

        if (loginUrl) {
            $.ajax(loginUrl, {
                type: 'GET',
                dataType: 'html',
                success: function (data) {
                    $.colorbox({
                        html: $(data),
                        scrolling: false,
                        innerWidth: 953,
                        top: 100,
                        onLoad: function () {
                            $('#cboxClose').remove();
                        },
                        onComplete: function () {
                            $.colorbox.resize();
                            KMVP.registration.initLoginRegisterFormHandler('#login-colorbox');
                        }
                    });
                }
            });
        }
    },

    /**
     * Bindings for Registration Form
     */
    initRegistrationFormHandler: function () {
        var $colorbox = $('#colorbox'),
            $wrapper = $colorbox.find('.userLoginRegister'),
            $registrationForm = $colorbox.find('#registrationForm');

        $registrationForm.ajaxForm({
            headers: {
                Accept: 'application/json'
            },
            global: false,
            beforeSerialize: function () {
                if (!KMVP.partnerInformation.isPartnerInformationRequired()) {
                    $('.js-registration-partner-information').remove(); // remove to prevent transmission of hidden data
                } else {
                    // reindex to prevent wrong order of entries or empty orders
                    reindexEntries($registrationForm.find('.js-registration-partner-information-entry'), 'partnerInformationForms');
                }
            },
            success: function (data) {
                // check result
                if ($(data).find('.userRegistration').length) {
                    // has validation errors
                    $wrapper.html($(data).find('.userRegistration:first-child'));
                } else if ($(data).find('.reload')) {
                    // registration success

                    var url = KMVP.registration.getAfterLoginUrl(data);

                    url = ACC.track.setUrlHash("currentRegistration", url);
                    setTimeout(function () {
                        ACC.track.setUrl(url)
                    }, 1000);
                } else {
                    // should never happen.
                    console.error("Illegal state for registration form.")
                }

                $.colorbox.resize();
                KMVP.registration.initRegistrationFormHandler();
                KMVP.partnerInformation.initPartnerInformation();
            },
            statusCode: {
                503: function (xhr) {
                    var $captchaImg = $('#colorbox').find('.js-myracloud-captcha .js-secure-image');
                    var $captchaElements = $('.js-myracloud-captcha-elements');
                    var myraJSON = jQuery.parseJSON(xhr.responseText);
                    var imageUrl = myraJSON.imageUrl;
                    var fieldName = myraJSON.fieldName;
                    var actionUrl = myraJSON.actionUrl;

                    // save action url
                    $captchaElements.attr('data-action-url', actionUrl);
                    // save image url for refresh
                    $captchaImg.attr('data-img-url', imageUrl);
                    // load image
                    $captchaImg.attr('src', imageUrl + "?" + new Date().getTime());
                    // set field name
                    $captchaElements.find('.js-input-captcha').attr('name', fieldName);

                    $('.registration-limiter').removeClass('hide');
                    $('.userRegistration .registrationForm').addClass('hide');

                    KMVP.registration.initMyraCaptchaHandler();

                    KMVP.overlays.setColorBoxFixedPosition(false);
                    $.colorbox.resize();
                }
            }
        });

        KMVP.overlays.initColorboxCloseButtonHandler();
        KMVP.registration.handleInputError();
        KMVP.partnerInformation.initPartnerInformation();
    },

    /**
     * Handle input errors for Registration Form
     */
    handleInputError: function () {
        $('.registrationForm').find('.second-row').each(function () {
            if ($(this).prev('.first-row').find('.help-inline').length > 0) {
                var error = $(this).find('.help-inline span').detach();
                error.appendTo($(this).prev('.first-row').find('.help-inline'));
            } else {
                var error = $(this).find('.help-inline').detach();
                error.appendTo($(this).prev('.first-row'));
            }
        });
    },

    initMyraCaptchaHandler: function () {
        var $captcha = $('#colorbox').find('.myracloud-captcha');
        var $captchaElements = $('.js-myracloud-captcha-elements');
        var $captchaSendButton = $captcha.find('.js-myracloud-captcha-send-button');
        var $captchaRefreshImgButton = $captcha.find('.js-reload-captcha .fa-refresh');
        var $captchaImg = $captcha.find('.js-secure-image');
        var $captchaInput = $captcha.find('.js-input-captcha');

        $captchaSendButton.on('click', function () {
            if ($captchaInput.val().length > 0 && $captchaInput.val().length <= 6) {
                $.ajax({
                    url: $captchaElements.attr('data-action-url'),
                    type: "POST",
                    data: {
                        'captcha_code': $captchaInput.val()
                    },
                    global: false,
                    success: function (xhr) {
                        if (xhr.success == true) {
                            // send registration again
                            $('.js-registration-limiter').addClass('hide');
                            $('.userRegistration .registrationForm').removeClass('hide');
                            $.colorbox.resize();
                            // automatic resend after successfull resolving captcha
                            /*$('.userRegistration .registrationForm').submit();*/
                        } else {
                            // show error msg for wrong captcha
                            $('.js-myracloud-captcha-wrong').removeClass('hide');
                            $.colorbox.resize();
                        }
                    },
                    statusCode: {
                        503: function (data) {
                            // show error msg for wrong captcha
                            $('.js-myracloud-captcha-wrong').removeClass('hide');
                            $.colorbox.resize();
                        }
                    },
                    error: function () {
                        // show error msg for technical problems with captcha
                        $captcha.addClass('hide');
                        $('.js-myracloud-captcha-technical-error').removeClass('hide');
                        $.colorbox.resize();
                    }
                })
            } else {
                // empty input
                $('.js-myracloud-captcha-wrong').removeClass('hide');
                $.colorbox.resize();
            }
        });

        $captchaRefreshImgButton.on('click', function () {
            var $imgUrl = $captchaImg.attr('data-img-url');
            $captchaImg.attr('src', $imgUrl + "?" + new Date().getTime());
        });

        $captchaInput.on('focus', function () {
            $('.js-myracloud-captcha-wrong').addClass('hide');
        });
    },

    /**
     * Retrieve url after login process
     * @param data (required)
     * @param requestedUrl (required)
     * @returns url for redirect
     */
    getAfterLoginUrl: function (data, requestedUrl) {
        if (requestedUrl) {
            if (requestedUrl.indexOf('/pdf/') === 0) {
                return requestedUrl.replace(/\/pdf\/.*\.pdf\?(.*)/, '/cart/triggerPdfDownload?$1')
            }
            return requestedUrl;
        } else if (data.url) { // open redirect url from backend
            return data.url;
        }
        return window.location.href;
    },

    /**
     * Handle Google Analytics
     */
    handleGATracking: function (hashTag) {
        if (!window.dataLayer) {
            return;
        }

        if (ACC.track.getUrlHash(hashTag)) {
            $('body').addClass(hashTag);
            if (typeof dataLayer !== "undefined") {
                dataLayer.push({
                    'par1': par1,
                    'par2': par2
                });
                ACC.track.setGaCookie(par1, par2);
            }
            ACC.track.removeUrlHash(hashTag);
        } else {
            $('body').removeClass(hashTag);
        }
    },


    /**
     * Opens a pdf in a new window when page is loaded
     */
    handlePDFLoadOnPageLoad: function () {
        var pdfDownloadUrl = $('input[name=triggerPdfDownloadCartUrl]').attr('val');
        if (pdfDownloadUrl) {
            window.open(pdfDownloadUrl);
        }
    }
};

$(document).ready(function () {
    with (KMVP.registration) {
        initLoginRegisterButtonHandler();
        initLoginRegisterFormHandler('#login-page');
        handlePDFLoadOnPageLoad();
    }
});
